export interface RecipePantryItem {
  id:   string
  name: string
}

export function matchIngredient(name: string, pantryItems: RecipePantryItem[]): boolean {
  const ing = name.toLowerCase().trim()
  return pantryItems.some(p => {
    const n = p.name.toLowerCase()
    return n === ing || n.includes(ing) || ing.includes(n) ||
      n.includes(ing.replace(/s$/, '')) || ing.includes(n.replace(/s$/, ''))
  })
}

export function getCategoryEmoji(category: string): string {
  switch (category) {
    case 'produce':    return '🥬'
    case 'dairy':      return '🥛'
    case 'meat':       return '🥩'
    case 'bakery':     return '🍞'
    case 'pantry':     return '🫙'
    case 'frozen':     return '🧊'
    case 'condiments': return '🫙'
    default:           return '📦'
  }
}

export function formatNumber(n: number): string {
  if (n === Math.round(n)) return String(Math.round(n))
  const fracs: [number, string][] = [
    [0.125, '⅛'], [0.25, '¼'], [0.33, '⅓'], [0.375, '⅜'],
    [0.5, '½'], [0.625, '⅝'], [0.67, '⅔'], [0.75, '¾'], [0.875, '⅞'],
  ]
  const whole = Math.floor(n)
  const dec   = n - whole
  for (const [val, sym] of fracs) {
    if (Math.abs(dec - val) < 0.04) return whole > 0 ? `${whole} ${sym}` : sym
  }
  return n.toFixed(1)
}

export function scaleAmount(amount: string, base: number, target: number): string {
  if (!amount || base === target) return amount
  const ratio = target / base
  const match = amount.match(/^(\d+(?:\.\d+)?(?:\/\d+)?)\s*(.*)/)
  if (!match) return amount
  const num  = match[1]
  const unit = match[2] || ''
  if (num.includes('/')) {
    const [a, b] = num.split('/').map(Number)
    return `${formatNumber((a / b) * ratio)} ${unit}`.trim()
  }
  return `${formatNumber(parseFloat(num) * ratio)} ${unit}`.trim()
}
